import React, { useEffect, useState } from 'react';
import {Badge, ButtonDropdown, SpaceBetween, TopNavigation} from '@amzn/awsui-components-react/polaris';
import logo from "./images/accounting-central-logo-no-background.png"
import { useAuth } from './context/AuthContextProvider';
import { Box } from '@amzn/awsui-components-react';
import { useSelector, useDispatch } from 'react-redux'
import { setCurrentAppAuthorization, setCurrentUserId, setCurrentFullName, setCurrentEmail, setIsPortalAdmin, setLoginRedirectPath, setIsSupportAdmin, setScreenWidth, setCurrentUserLDAPS, setIsCorpReportingAdmin, setIsFirstPassProFullUser, toggleAdminViewAsNonAdmin} from './store/userAuthSlice'
import checkPageAccess, { checkGeneralAccess, fetchAndCacheAllLdaps, isFirstPassProFullUser } from './checkPageAccess'

import {checkIfPortalAdmin, checkIfSupportAdmin, getCacheKey, getCachedResult} from './checkPageAccess'
import {ACCESS_LEVEL_IDs, ADD_APP_ACCESS_LEVELS} from './constants/AppConstants'
import {getAccessLevel} from './checkPageAccess'
import {useHistory} from 'react-router-dom'
import appSettings from './Ateam-BI/CorpReporting/app_settings';
import { Link, useLocation, useParams } from "react-router-dom";
import { BUTTON_LINKS } from './Ateam-BI/CorpReporting/FlexicoConstants';
import { isCorpAdmin } from './Ateam-BI/Templates/Utils/Permissions';
import { selectIsEffectiveAdmin, selectIsActualAdmin, selectAdminViewAsNonAdmin } from './utilities/adminUtils';
import { TEMPLATES } from './Ateam-BI/Templates/Constants';



function TopNav() {  

  const userAuthenticationDetails = useAuth();

  const userLDAPS = userAuthenticationDetails.USER_LDAP_GROUPS;
  const userId  = userAuthenticationDetails.Alias;
  const userEmail  = userAuthenticationDetails.Email;
  const userGivenName = userAuthenticationDetails.DisplayName;
  const [width, setWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();
  const currentAppId = useSelector((globalState)=>globalState.auth.currentAppId)
  const currentAppPage = useSelector((globalState)=>globalState.auth.currentAppPage)
  const currentStage = useSelector((globalState)=>globalState.auth.currentStage)
  const isPortalAdmin = useSelector(selectIsEffectiveAdmin)
  const isActualAdmin = useSelector(selectIsActualAdmin)
  const adminViewAsNonAdmin = useSelector(selectAdminViewAsNonAdmin)
  const isSupportAdmin = useSelector((globalState)=>globalState.auth.isSupportAdmin)
  const currentUser = useSelector((globalState)=>globalState.auth.userId)
  const loginRedirectPath = useSelector((globalState)=>globalState.auth.loginRedirectPath)
  const organization = useSelector((globalState)=>globalState.auth.organization)
  const screenWidth = useSelector((globalState)=>globalState.auth.screenWidth)
  const [isAiRepoAdmin, setIsAiRepoAdmin] = useState(false)
  const ln = useLocation()
  const history = useHistory()
  const title = (
    <SpaceBetween direction='horizontal' size='m'>
      <Box variant='h3'> {organization ? <Box>  - {organization} </Box> : <></>}</Box>
      {
        currentStage != 'prod' ? <Badge color="severity-medium">{currentStage}</Badge> : <></>
      }
    </SpaceBetween>
  )
  const reportCRA = (
    <Box>
      {
        currentAppId == appSettings[currentStage]?.appId && <ButtonDropdown
          items={BUTTON_LINKS}
          variant="primary"
        >
          Report An Issue
        </ButtonDropdown>
      }

    </Box>
  )

  const displayName = adminViewAsNonAdmin ? `${userGivenName} (non-admin)` : userGivenName;
  
  useEffect(() => {
    dispatch(setCurrentUserId(userId))
    dispatch(setCurrentFullName(userGivenName))
    dispatch(setCurrentEmail(userEmail))
    dispatch(setCurrentUserLDAPS(userLDAPS))
    if(loginRedirectPath && userId) {
      const path = loginRedirectPath;
      dispatch(setLoginRedirectPath(null))
      history.push(path)
    }
  },[loginRedirectPath]);

  useEffect(() => {
    async function checkPortalAdminUser() {
      if (isActualAdmin === false || isActualAdmin === null) {
        const result = await checkIfPortalAdmin(userId, currentStage);
        dispatch(setIsPortalAdmin(result));
      }
    }

    async function checkSupportAdminUser() {
      if (isSupportAdmin === false || isSupportAdmin === null) {
        const result = await checkIfSupportAdmin(userId, currentStage);
        dispatch(setIsSupportAdmin(result));
      }
    }

    async function checkCorpReportingAdminUser() {
      if (isSupportAdmin === false || isSupportAdmin === null) {
        let accessPerms = await isCorpAdmin(userId, appSettings[currentStage].appId, currentStage)
        dispatch(setIsCorpReportingAdmin(accessPerms?.admin));
      }
    }

    async function checkIsFirstPassProFullUser() {
      if (isActualAdmin === false || isActualAdmin === null) {
        const result = await isFirstPassProFullUser(userId, currentStage);
        dispatch(setIsFirstPassProFullUser(result));
      }else{
        dispatch(setIsFirstPassProFullUser(true));
      }
    }
    
    
    if (userId && currentStage) {
      checkPortalAdminUser()
      checkSupportAdminUser()
      checkCorpReportingAdminUser()
      checkIsFirstPassProFullUser()
      fetchAndCacheAllLdaps(currentStage)
      // Check AI Repo Admin
      getAccessLevel(userId, TEMPLATES.AI, currentStage).then(aiAccess => {
        if (ADD_APP_ACCESS_LEVELS.includes(aiAccess?.appAccessLevel)) {
          setIsAiRepoAdmin(true);
        }
      }).catch(() => {});
    }

    
    
  }, [currentUser, currentStage, isActualAdmin, isSupportAdmin]);
  
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    useEffect(()=>{
      dispatch(setScreenWidth(width))
    },[width])

  useEffect(() => {
    
    async function checkUserAuthorizedForApp (){

      if(currentAppId && userId && currentStage) {

      dispatch(setCurrentAppAuthorization(null))
      const params = {userAlias: userId,
         id: currentAppId,
         stage: currentStage
        }
      const result = await checkGeneralAccess(params);
      dispatch(setCurrentAppAuthorization(result))

    }
  }
    
      if(isPortalAdmin) {
        dispatch(setCurrentAppAuthorization(true))
      } else {
          checkUserAuthorizedForApp()
      }
    return () => {
      // this now gets called when the component unmounts
    };
  }, [currentAppId, currentStage, isPortalAdmin]);

  const handleAdminToggle = () => {
    dispatch(toggleAdminViewAsNonAdmin());
  };

  const userDropdownItems = isActualAdmin ? [
    { 
      id: "admin-view-toggle", 
      text: adminViewAsNonAdmin ? "View as Admin" : "View as Non-Admin",
      iconName: adminViewAsNonAdmin ? "lock-private" : "unlocked"
    }
  ] : [];

  const handleUserDropdownClick = (event) => {
    if (event.detail.id === "admin-view-toggle") {
      handleAdminToggle();
    }
  };

  
    return (
      <div id='h'>
        <TopNavigation
          identity={{
            href: currentAppId == appSettings[currentStage]?.appId ? "/CorpReportingHome" : organization ? `/Org/${organization}` : "/",
            title: title,
            logo: {
              src:
                `${logo}`,
              alt: title,
            }
          }}
        utilities={(isPortalAdmin || isAiRepoAdmin) ? [
          {
            type: "button",
            text: (reportCRA),
            external: false
          },{
            type: "button",
            text: "Contact us",
            href: "https://t.corp.amazon.com/create/templates/9c41d7b9-b693-433e-950a-ec29fcfce9f5",
            iconName: "external",
            external: true
          },{
            type: "button",
            text: "Admin panel",
            href: isAiRepoAdmin && !isPortalAdmin ? "/Admin?tab=ai-repo-control-panel" : "/Admin",
            iconName: "settings",
            external: false
          },
          {
            type: "menu-dropdown",
            text: `${displayName}`,
            description: `${userEmail}`,
            iconName: "user-profile",
            onItemClick: handleUserDropdownClick,
            items: userDropdownItems
          },
          {
          
            type:"button",
            text: (
              
            <img
                alt=""
                className="rounded-circle"
                src={'https://badgephotos.corp.amazon.com/?uid=' + userId}
                width={35}
                height={35}
            />          
            ),
             href: 'https://phonetool.amazon.com/users/' + userId,
          },
          {
            type:"button",
            text:(<Box color='text-status-info'>{currentStage === 'prod' ? '' : currentStage}</Box> )
          },
        ]: [
          {
            type: "button",
            text: (reportCRA),
            external: false
          },{
            type: "button",
            text: "Contact us",
            href: "https://t.corp.amazon.com/create/templates/9c41d7b9-b693-433e-950a-ec29fcfce9f5",
            iconName: "external",
            external: true
          },{
            type: "menu-dropdown",
            text: `${displayName}`,
            description: `${userEmail}`,
            iconName: "user-profile",
            onItemClick: handleUserDropdownClick,
            items: userDropdownItems
          },
          {
          
            type:"button",
            text: (
              
            <img
                alt=""
                className="rounded-circle"
                src={'https://badgephotos.corp.amazon.com/?uid=' + userId}
                width={35}
                height={35}
            />          
            ),
             href: 'https://phonetool.amazon.com/users/' + userId,
          },
          {
            type:"button",
            text:(<Box color='text-status-info'>{currentStage === 'prod' ? '' : currentStage}</Box> )
          },
        ]}
        i18nStrings={{
          searchIconAriaLabel: "Search",
          searchDismissIconAriaLabel: "Close search",
          overflowMenuTriggerText: "More",
          overflowMenuTitleText: "All",
          overflowMenuBackIconAriaLabel: "Back",
          overflowMenuDismissIconAriaLabel: "Close menu"
        }}
      /> 
    </div>
    );
}

export default TopNav;
